<template>
  <div class="mx-5">
    <v-row>
      <v-col cols="12" md="9" sm="12" :style="$vuetify.breakpoint.mdAndDown ? 'margin-bottom: 200px' : ''">
        <v-card flat style="margin-bottom: 10%">
          <v-toolbar flat class="pa-2">
            <v-toolbar-title>Info dan Detil Kelas</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-spacer />
          <v-card-text>
            <div class="mx-n4 mt-n3 primary">
              <v-toolbar style="height: 45px" flat :color="getColor(Number(detail && detail.k_verval_paud))">
                <v-toolbar-title style="height: 45px" class="white--text py-0">Status Ajuan</v-toolbar-title>
                <v-spacer />
                <span class="white--text body-1 font-italic" style="height: 45px">
                  <b>{{ $getDeepObj(detail, 'status.keterangan') || '' }}</b>
                </span>
              </v-toolbar>
            </div>
            <v-container class="black--text">
              <v-row dense no-gutters class="my-5">
                <v-col cols="12" md="1" sm="2" class="pa-0">
                  <v-avatar color="primary" size="60">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" md="11" sm="10" class="px-0">
                  <div>
                    <div class="label--text">Nama Kelas</div>
                    <div class="body-1">
                      {{ $getDeepObj(detail, 'nama') || '-' }}
                    </div>
                    <div class="font-italic">
                      {{ $getDeepObj(detail, `${paudDiklatKey}.data.instansi.data.nama`) || '-' }}
                    </div>
                  </div>
                  <div class="my-5">
                    <div class="label--text">Deskripsi Kelas</div>
                    <div class="body-1">{{ $getDeepObj(detail, 'deskripsi') || '' }}</div>
                  </div>
                  <div class="my-5">
                    <div class="label--text">Lokasi</div>
                    <div class="body-1">
                      {{
                        [
                          $getDeepObj(detail, 'm_kelurahan.data.keterangan') || '',
                          $getDeepObj(detail, 'm_kecamatan.data.keterangan') || '',
                          $getDeepObj(detail, `${paudDiklatKey}.data.m_kota.data.keterangan`) || '',
                          $getDeepObj(detail, `${paudDiklatKey}.data.m_propinsi.data.keterangan`) || '',
                        ].join(', ')
                      }}
                    </div>
                  </div>
                  <v-row class="my-5">
                    <v-col>
                      <div class="label--text">Tanggal Mulai Kelas</div>
                      <div class="body-1">
                        <template v-if="akses === 'daring'">
                          {{
                            $localDate($getDeepObj(detail, `paud_diklat.data.paud_periode.data.tgl_diklat_mulai`)) ||
                            '-'
                          }}
                        </template>
                        <template v-else>
                          {{ $localDate($getDeepObj(detail, `${paudDiklatKey}.data.tgl_mulai`) || '') }}
                        </template>
                      </div>
                    </v-col>
                    <v-col>
                      <div class="label--text">Tanggal Selesai Kelas</div>
                      <div class="body-1">
                        <template v-if="akses === 'daring'">
                          {{
                            $localDate($getDeepObj(detail, 'paud_diklat.data.paud_periode.data.tgl_diklat_selesai')) ||
                            '-'
                          }}
                        </template>
                        <template v-else>
                          {{ $localDate($getDeepObj(detail, `${paudDiklatKey}.data.tgl_selesai`) || '') }}
                        </template>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="my-5">
                    <v-col>
                      <div class="label--text">Jenis Diklat</div>
                      <div class="body-1">
                        <template v-if="['daring', 'luring'].includes(akses)">
                          {{
                            M_DIKLAT_PAUD[
                              $getDeepObj(
                                detail,
                                `paud_diklat${akses === 'luring' ? '_luring' : ''}.data.k_diklat_paud`
                              ) || 1
                            ]
                          }}
                        </template>
                        <template v-else>
                          {{
                            M_DIKLAT_REFRESHMENT[
                              $getDeepObj(detail, `paud_diklat_bimtek.data.k_diklat_bimtek_paud`) || 1
                            ]
                          }}
                        </template>
                      </div>
                    </v-col>
                    <v-col>
                      <div class="label--text">Jenjang DIklat</div>
                      <div class="body-1">
                        {{
                          M_JENJANG_DIKLAT_PAUD[$getDeepObj(detail, `${paudDiklatKey}.data.k_jenjang_diklat_paud`) || 1]
                        }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="jenis === 'kelas'">
                    <v-col cols="12" md="12" sm="12">
                      <berkases
                        :berkas="berkases"
                        :valid="($getDeepObj(berkases, 'url') || '') !== ''"
                        :use-icon="false"
                        :value="berkases"
                        @detil="onPreview"
                      />
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <div class="my-2" v-if="Number(detail && detail.k_verval_paud) === 6 && akses === 'daring'">
                        <v-btn
                          color="success"
                          depressed
                          :disabled="$isTutupLms || !$getDeepObj(detail, 'lms_url')"
                          small
                          @click="onLms($getDeepObj(detail, 'lms_url'))"
                          ><v-icon left>mdi-link</v-icon> Menuju LMS</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-tabs v-model="tab" fixed-tabs>
                <v-tab v-for="item in tabItems" :key="item.value">
                  {{ item.text }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab" class="my-3">
                <v-tab-item v-for="item in tabItems" :key="item.value">
                  <v-toolbar flat>
                    <v-toolbar-title class="body-2">Daftar {{ item.text }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      dense
                      placeholder="Pencarian Data"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </v-toolbar>

                  <div class="my-4">
                    <v-data-table
                      :headers="headers"
                      :items="filteredItems"
                      :no-data-text="`Daftar ${item.text} belum ditemukan`"
                    >
                      <template v-slot:[`item.aksi`]="{ item }">
                        <template v-if="item && item.dapodik !== 'Dapodik'">
                          <v-btn depressed dark color="blue" small @click="onDetil(item)"> Detail </v-btn>
                        </template>
                      </template>
                    </v-data-table>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="12"
        :style="`position: fixed; right: 10px; ${$vuetify.breakpoint.mdAndDown ? 'bottom: 0;' : ''} z-index: 1`"
      >
        <v-card flat>
          <v-card-text>
            <v-container>
              <v-row no-gutters dense>
                <v-col cols="12" md="12" sm="12">
                  <div class="black--text my-2 ml-1">
                    <h2 class="mb-3">Pemeriksaan Dokumen</h2>
                    Berikan Penilaian pada kelengkapan dan keabsahan dokumen ini,
                    <b>Apakah semua dokumen sah dan sesuai</b>
                    dengan data yang di inputkan kandidat ?
                  </div>
                  <v-card flat :disabled="isDisable" class="my-5">
                    <v-row dense>
                      <template v-for="item in mBtnPilihan">
                        <v-col :key="item.value" md="12" sm="12" class="my-auto">
                          <v-btn
                            block
                            dark
                            :color="item.color"
                            :outlined="pilihan !== item.value"
                            @click="onSelected(item.value)"
                            style="background-color: white; justify-content: start"
                          >
                            <v-icon small left>{{ item.icon }}</v-icon
                            >{{ item.label }}
                          </v-btn>
                        </v-col>
                      </template>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" :class="[isEdit ? 'mt-3' : '']">
                  <template v-if="pilihan && !isDisable">
                    <div class="pa-4" v-if="$isObject(schema[pilihan])">
                      <b class="black--text">{{ schema[pilihan]['label'] }} *</b><br />
                      <validation-provider
                        mode="passive"
                        :name="schema[pilihan]['label']"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-textarea
                          required
                          v-model="form.alasan"
                          :error-messages="errors"
                          :disabled="isDisable"
                          rows="1"
                          single-line
                          outlined
                        />
                      </validation-provider>
                    </div>
                  </template>
                  <template v-if="!isEdit || isDisable">
                    <b class="black--text">Catatan Verval*</b><br />
                    <v-card flat outlined>
                      <v-card-text v-html="catatan"></v-card-text>
                    </v-card>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <popup-preview-detail ref="popup" :url="$getDeepObj(preview, 'url')" :title="$getDeepObj(preview, 'title')" />
    <base-modal-full ref="modal" colorBtn="primary" generalError :use-save="false" title="Detail Peserta">
      <info-peserta :init-value="infoPeserta" :noFoto="true"></info-peserta>
    </base-modal-full>
  </div>
</template>
<script>
import InfoPeserta from '../../peserta/formulir/InfoPeserta';
import { ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';
import Berkases from '../../profil/formulir/Berkas';
import PopupPreviewDetail from '@components/popup/PreviewDetil';
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    berkas: {
      type: Array,
      default: () => [],
    },
    masters: {
      type: Object,
      default: () => {},
    },
    jenis: {
      type: String,
      default: 'lpd',
    },
    obj: {
      type: String,
      default: 'instansi',
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    akses: {
      type: String,
      default: 'daring',
    },
  },
  components: { ValidationProvider, Berkases, PopupPreviewDetail, InfoPeserta },
  data() {
    return {
      preview: {},
      form: {},
      pesertas: [],
      pilihan: null,
      tab: null,
      search: '',
      catatan: 'dasdsa',
      mBtnPilihan: [
        {
          label: 'SETUJU',
          icon: 'mdi-check',
          color: 'success',
          value: 2,
          akses: true,
        },
        {
          label: 'PERBAIKAN',
          icon: 'mdi-pencil',
          color: 'warning',
          value: 3,
          akses: true,
        },
        {
          label: 'TOLAK',
          icon: 'mdi-close',
          color: 'red',
          value: 1,
          akses: true,
        },
      ],
      formulir: {},
      infoPeserta: {},
      M_DIKLAT_REFRESHMENT: {
        1: 'BIMTEK_PPM	Bimtek Penyegaran Pengajar Pendalaman Materi',
        2: 'BIMTEK_PPTM	Bimtek Pembekalan Pembimbing Praktik Tugas Mandiri',
      },
      M_DIKLAT_PAUD: {
        1: 'Diklat Berjenjang',
        2: 'Diklat PCP',
        3: 'Diklat MOT',
        4: 'Diklat Lainnya',
      },
      M_JENJANG_DIKLAT_PAUD: {
        1: 'Dasar',
        2: 'Lanjut',
        3: 'Mahir',
      },
    };
  },
  computed: {
    paudDiklatKey() {
      const keys = {
        daring: 'paud_diklat',
        luring: 'paud_diklat_luring',
        refreshment: 'paud_diklat_bimtek',
      };

      return keys[this.akses] || 'paud_diklat';
    },

    tabItems() {
      let temp = [
        { value: 'peserta', kPetugas: 0, text: 'Peserta' },
        { value: 'admin', kPetugas: 4, text: 'Admin Kelas' },
        { value: 'pembimbing-praktik', kPetugas: 3, text: 'Pembimbing' },
        { value: 'pengajar', kPetugas: 1, text: 'Pengajar' },
        { value: 'pengajar-tambahan', kPetugas: 2, text: 'Pengajar Tambahan' },
      ];

      if (this.akses === 'refreshment') {
        return temp.filter((item) => ['peserta', 'pengajar', 'admin'].includes(item.value)) || [];
      } else {
        return temp;
      }
    },

    headers() {
      let temp = [
        {
          text: 'Nama Lengkap',
          align: 'start',
          sortable: false,
          value: 'nama',
        },
        { text: 'Surel', value: 'email', sortable: false },
      ];

      // Tambahkan info provinsi dan kota pada tab pembimbing praktik
      if (this.tab >= 2) {
        temp.push({ text: 'Provisi', value: 'propinsi', sortable: false });
        temp.push({ text: 'Kota/Kabupaten', value: 'kota', sortable: false });
      }

      // Tambahkan tab info dapodik

      if (this.tab === 0 && this.akses === 'luring') {
        temp.push({ text: 'Keterangan', value: 'dapodik', sortable: false });
        temp.push({ text: '', value: 'aksi', sortable: false });
      }

      if (
        (![0, 1].includes(this.tab) && this.akses === 'luring') ||
        (![1].includes(this.tab) && this.akses === 'daring')
      ) {
        temp.push({ text: 'Status', value: 'status', sortable: false });
      }

      return temp;
    },

    items() {
      return (this.pesertas || []).map((item) => {
        return {
          nama:
            this.$getDeepObj(item, 'ptk.data.nama') ||
            this.$getDeepObj(item, 'akun.data.nama') ||
            this.$getDeepObj(item, 'paud_peserta_nonptk.data.nama') ||
            '-',
          email:
            this.$getDeepObj(item, 'ptk.data.email') ||
            this.$getDeepObj(item, 'akun.data.email') ||
            this.$getDeepObj(item, 'paud_peserta_nonptk.data.email') ||
            '-',
          status: this.$getDeepObj(item, 'm_konfirmasi_paud.data.keterangan') || '-',
          dapodik: item && Number(item.is_nonptk) === 1 ? 'Non Dapodik' : 'Dapodik',
          paud_kelas_petugas_id: this.$getDeepObj(item, 'paud_kelas_petugas_id'),
          paud_kelas_peserta_id: this.$getDeepObj(item, 'paud_kelas_peserta_id') || '',
          paud_kelas_peserta_luring_id: this.$getDeepObj(item, 'paud_kelas_peserta_luring_id') || '',
          ptk_id: this.$getDeepObj(item, 'ptk_id') || '',
          propinsi: this.$getDeepObj(item, 'akun.data.m_propinsi.data.keterangan') || '-',
          kota: this.$getDeepObj(item, 'akun.data.m_kota.data.keterangan') || '-',
        };
      });
    },

    filteredItems() {
      return this.items.filter((s) => {
        return s.nama.toLowerCase().includes(this.search.toLowerCase());
      });
    },

    schema() {
      return {
        1: {
          label: 'Alasan ajuan ditolak',
          items: this.catatan,
        },
        2: {},
        3: {
          label: 'Alasan ajuan butuh diperbaiki',
          items: this.catatan,
        },
      };
    },

    berkases() {
      return {
        title: 'Jadwal Diklat Dasar',
        pesan: ``,
        url: this.$getDeepObj(this, 'detail.url_jadwal'),
      };
    },
  },

  methods: {
    ...mapActions('diklatVerval', ['getListKelas', 'getDetailPeserta']),

    getValue() {
      return { pilihan: this.pilihan, id: this.id, alasan: (this.form && this.form.alasan) || '' };
    },

    reset() {
      this.pilihan = null;
      this.$set(this, 'form', {});
      this.tab = 0;
      this.search = '';
      this.infoPeserta = {};
    },

    initForm(value) {
      this.$set(this, 'pilihan', (value && value.pilihan) || null);
      this.$set(this, 'catatan', (value && value.catatan) || null);
    },

    fetch(tipe, k_petugas = null) {
      if (!this.$getDeepObj(this.detail, 'id')) return;
      let params = {
        k_petugas_paud: k_petugas,
        count: 50,
      };

      if (this.jenis === 'kelas-refreshment' && [1, 2, 3].includes(k_petugas)) {
        this.$delete(params, 'k_petugas_paud');
      }

      this.getListKelas({
        id: this.$getDeepObj(this.detail, 'id'),
        diklatId: this.$getDeepObj(this.detail, `${this.paudDiklatKey}.data.id`),
        tipe: tipe,
        params,
      }).then(({ data }) => {
        this.pesertas = data || [];
      });
    },

    onSelected(value) {
      this.$set(this, 'pilihan', value);
    },

    onPreview(berkas) {
      this.$set(this, 'preview', {});
      this.preview.url = this.$getDeepObj(berkas, 'url');
      this.preview.title = this.$getDeepObj(berkas, 'title');
      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },

    onLms(url) {
      window.open(url, '_blank');
    },

    async onDetil(data) {
      const resp = await this.getDetailPeserta({
        id: this.id,
        peserta_id: this.$getDeepObj(data, 'paud_kelas_peserta_luring_id'),
      }).then(({ data }) => data);

      this.infoPeserta = this.$getDeepObj(resp, 'paud_peserta_nonptk.data') || {};
      this.$refs.modal.open();
    },

    getColor(value) {
      switch (value) {
        case 1:
          return 'primary';
        case 2:
          return 'info';
        case 3:
          return 'purple';
        case 4:
          return 'red';
        case 5:
          return 'warning';
        case 6:
          return 'success';
        default:
          return 'grey';
      }
    },
  },
  watch: {
    initValue: 'initForm',
    tab: function (value) {
      this.pesertas = [];
      switch (Number(value)) {
        case 0:
          this.fetch('peserta');
          break;
        case 1:
          this.fetch('petugas', 4);
          break;
        case 2:
          this.fetch('petugas', 3);
          break;
        case 3:
          this.fetch('petugas', 1);
          break;
        case 4:
          this.fetch('petugas', 2);
          break;
      }
    },
    detail: {
      handler(value) {
        if (value && value.id) {
          this.fetch('peserta');
        }
      },
      deep: true,
    },
  },
};
</script>
